import { render, staticRenderFns } from "./SettingsCompanyDetails.vue?vue&type=template&id=70f74b57"
import script from "./SettingsCompanyDetails.vue?vue&type=script&lang=js"
export * from "./SettingsCompanyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports